import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import client from '../client';

const openItemSchema = z.object({
  open_item_id: z.string(),
  grant_id: z.string(),
  tax_year: z.number().int(),
  kind: z.enum(['coverage_gap', 'ambiguous_deposit', 'uncategorized', 'missing_1099', 'missing_receipt', 'mileage_log', 'home_office', 'accountant_question']),
  source_key: z.string(),
  title: z.string(),
  message: z.string(),
  status: z.enum(['draft', 'sent', 'answered', 'resolved', 'reopened']),
  batch_id: z.string().nullable(),
  version: z.number().int().positive(),
  answer_text: z.string().nullable(),
  answered_at: z.string().nullable(),
});

const openItemsDataSchema = z.object({
  counts: z.record(z.string(), z.number().int().nonnegative()),
  items: z.array(openItemSchema),
  generation_as_of: z.string(),
});

export type OpenItem = z.infer<typeof openItemSchema>;
export type OpenItemsData = z.infer<typeof openItemsDataSchema>;

export function useOpenItems(grantId: string | undefined, taxYear: number | undefined) {
  return useQuery<OpenItemsData>({
    queryKey: ['accountant-open-items', grantId, taxYear],
    enabled: Boolean(grantId && taxYear),
    queryFn: async () => {
      const response = await client.get(`/api/accountant/clients/${grantId}/years/${taxYear}/open-items`);
      const payload = response.data?.data ?? response.data;
      return openItemsDataSchema.parse(payload);
    },
  });
}

